import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { AreaItemPack } from '../../models/area-item-pack';
import { AreaItem } from '../../models/area-item';
import { ViewType } from '../../../general/models/view-type';

@Component({
  selector: 'app-booking-area-item-pack',
  templateUrl: './booking-area-item-pack.component.html',
  styleUrls: ['./booking-area-item-pack.component.css']
})
export class BookingAreaItemPackComponent implements OnInit {

  @Input()
  maxLenNamePack = 0;

  @Input()
  areaItemPack: AreaItemPack;

  @Input()
  showDescription = true;

  @Input()
  viewType: ViewType = ViewType.Buttons;

  @Output() areaItemSelected: EventEmitter<any> = new EventEmitter<any>();

  private _areaItems: AreaItem[];

  constructor() {
  }

  ngOnInit() {
  }

  get description(): string {
    return this.showDescription ? this.areaItemPack.description : '';
  }

  get additionalDescription(): string {
    return this.showDescription ? this.areaItemPack.additionalDescription : '';
  }

  get areaItems(): AreaItem[] {
    if (!this.areaItemPack) {
      return Array.of();
    }
    return this.areaItemPack.areaItems;
  }

  areaItemPackClick(areaItemPack: AreaItemPack) {
    if (areaItemPack.hasEvents) {
      if (this.areaItemPack && this.areaItemPack.areaItems && this.areaItemPack.areaItems.length !== 0) {
        this.areaItemSelected.emit(this.areaItemPack.areaItems[0]);
      }
    } else {
      this.areaItemSelected.emit(null);
    }
  }

  get isButtonsViewType(): boolean {
    return this.viewType === ViewType.Buttons;
  }
}
